module.exports = __webpack_public_path__ + "media/images/spree/frontend/credit_cards/master_cid-bf311bb075b08b958efb518f2fc4166d.jpg";